import { Loader2 } from 'lucide-react'

interface LoadingScreenProps {
  label?: string
}

export function LoadingScreen({ label = 'Loading' }: LoadingScreenProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-dvh items-center justify-center"
    >
      <Loader2 className="size-6 animate-spin text-muted-foreground" aria-hidden />
      <span className="sr-only">{label}</span>
    </div>
  )
}
